import React from "react";
import { Button } from "antd";
import AdminAddUserAccount from "../../components/tables/AdminAddUserAccount";

const AdminAddUserAccountPage = () => {
	return (
		<>
			<AdminAddUserAccount button={Button} />
		</>
	);
};

export default AdminAddUserAccountPage;
